<template>
      <el-table
        :data="userNotifyConfigTableData"
        style="margin-bottom:30px;">
        <el-table-column
          prop="eventTypeName">
        </el-table-column>

        <el-table-column
          label="邮件">
          <template slot-scope="scope">
            <UserNotifyConfigSwitch
              :eventType="userNotifyConfigTableData[scope.$index].eventType"
              :notifyType="'Mail'"
              v-model="userNotifyConfigTableData[scope.$index].Mail"
              @update="notifyConfigUpdate"/>
          </template>
        </el-table-column>

        <el-table-column
          label="企业微信">
          <template slot-scope="scope">
            <UserNotifyConfigSwitch 
              :eventType="userNotifyConfigTableData[scope.$index].eventType"
              :notifyType="'WorkWeixin'"
              v-model="userNotifyConfigTableData[scope.$index].WorkWeixin"
              @update="notifyConfigUpdate"/>
          </template>
        </el-table-column>

        <el-table-column
          label="APP">
          <template slot-scope="scope">
            <UserNotifyConfigSwitch 
              :eventType="userNotifyConfigTableData[scope.$index].eventType"
              :notifyType="'App'"
              v-model="userNotifyConfigTableData[scope.$index].App"
              @update="notifyConfigUpdate"/>
          </template>
        </el-table-column>

        <el-table-column
          label="小助手">
          <template slot-scope="scope">
            <UserNotifyConfigSwitch 
              :eventType="userNotifyConfigTableData[scope.$index].eventType"
              :notifyType="'Hawkeye'"
              v-model="userNotifyConfigTableData[scope.$index].Hawkeye"
              @update="notifyConfigUpdate"/>
          </template>
        </el-table-column>
      </el-table>
</template>

<script>
export default {
  name: "UserNotifyConfigTable",

  data() {
    return {
      userNotifyConfigTableData : []
    };
  },

  methods: {
    notifyConfigUpdate(conf) {
      var _this = this;

      sdk.UserNotifyConfigApi().updateUserConf(conf).then(() => {
        _message("修改成功");
        _this.showUserNotifyConfig();
      });
    },

    eventTypeNames(){
      return {
        "TicketForDealUser" : "当有工单指派给我时",
        "TicketGoDepartment" : "当有工单指派给我所在的组时",
        "TicketForCopyUser" : "当有工单抄送给我时",
        "ReplyTicketForCreatorUser" : "当我创建的工单有人响应时",
        "ReplyTicketForDealUser" : "我处理的工单状态变化时",
        "disabled-1" : "当我创建的工单状态变化时",
        "TicketReportDaily" : "每天17:30给我发送工单日报",
        "TicketReportWeekly" : "每周五17:30给我发送工单周报"
      };
    },

    eventTypeName(_key) {
      var _names = this.eventTypeNames();

      var _val = _names[_key];
      if( !!_val ) {
        return _val;
      }

      return _key;
    },

    showUserNotifyConfig( _uid ) {
      var _this = this;

      sdk.UserNotifyConfigApi().listByUserId({
        userId : _uid
      }).then(res=>{
        var _data = { };
        var _names = this.eventTypeNames();

        // 初始化列表
        for (var _a in  _names) {
          _data[_a]= { eventType : _a };
        }

        // 数据填入
        for ( var i=0; i < res.length; i++ ) {
          var _a = _data[res[i].eventType];

          var _b = res[i].notifyType;
          _a[_b] = res[i].open;
        }

        // 转格式
        _this.userNotifyConfigTableData = [];
        for ( var i in _data ) {
          _data[i].eventTypeName = _this.eventTypeName(i);
          _this.userNotifyConfigTableData.push(_data[i]);
        }

        _this.userNotifyConfigDialogVisible = true;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ticket/UserNotifyConfigTable.vue